import { LOCAL_STORAGE_KEYS } from "@app/dashboard/constants/local-storage-keys";
import { getFromLocalStorage } from "../manageLocalStorage";

export const userInfo = () => {

  const {
    LOGO_URL: logo,
    FIRST_NAME: firstName,
    LAST_NAME: lastName,
    NAME: userName,
    COMPANY_NAME: companyName,
    PROFILE_TYPE: profileType,
    MERCHANT_ID: mId,
    ID: staffId
  } = Object.fromEntries(
    Object.entries(LOCAL_STORAGE_KEYS).map(([key, value]) => [key, getFromLocalStorage(value) || ""])
  );

  const shortName = (
    (
      (!firstName && !lastName) ?
        userName.slice(0, 2) || ""
        :
        firstName[0] + lastName[0]
    )
    ||
    ""
  ).toUpperCase();

  return {
    logo,
    firstName,
    lastName,
    userName,
    companyName,
    shortName,
    profileType,
    mId,
    staffId
  }
};